import { Injectable } from '@angular/core';
import { SESSION_STORAGE, StorageService, User, Util } from "@phdsoft/common";
import { AssetManager } from "src/app/asset-manager/asset-manager";
import { NotificationService } from 'src/app/signalr/notification.service';
import { AssetService } from 'src/app/shared/services/asset.service';

@Injectable({
  providedIn: 'root'
})
export class FeaBaseProcessService {

  constructor(
    protected readonly storageService: StorageService,
    protected readonly assetManager: AssetManager,
    protected readonly assetService: AssetService,
    protected readonly notificationService: NotificationService,
  ) {
  }

  public async getBaseProcessRequest(): Promise<any> {
    const user: User = await this.storageService.getItem(SESSION_STORAGE.USER);

    let asset = await this.assetService.getCurrentAsset(this.assetService.assetId);

    // if (asset?.AssetInfo?.IsCad) {
    //   this.notificationService.addFailedNotification("Error retrieving FEA asset data");
    //   return;
    // }

    let tempAssetId: string;
    if (!asset?.AssetInfo?.AssetId) {
      const storedAssetId = await this.storageService.getItem(SESSION_STORAGE.CURRENT_ASSET_ID);
      tempAssetId = String(storedAssetId);
    }
    if (Util.isNullOrUndefined(tempAssetId)) {
      tempAssetId = asset.AssetId;
    }

    // Added as a fallback to get the AssetId
    const assetId: string = tempAssetId ??
      this.assetService.assetId;

    const refDate = this.assetManager.referenceDate;

    return {
      ClientId: asset?.AssetInfo?.CustomerId,
      AssetId: assetId,
      UserId: user.id,
      ReferenceDate: new Date(refDate.getFullYear(), refDate.getMonth(), refDate.getDate()),
    }
  }
}
